<ui-banner variant="warning" class="margin-bottom-3">
    <p>{{ 'payroll.records.details.humiDoesNotRemitThesePayments' | translate }}</p>
</ui-banner>

<div class="flex justify-space-between" *ngFor="let wcbPremium of payroll.wcbPremiums">
    <p>{{ wcbPremium.displayName | translate }}</p>
    <p>{{ wcbPremium.amount | currency }}</p>
</div>

<div class="flex justify-space-between">
    <p class="font-bold">{{ 'payroll.records.details.workersCompensationTotal' | translate | i18nLabel }}</p>
    <p class="font-bold">{{ payroll.totalWcbPremiums | currency }}</p>
</div>

<hr />

<div class="flex justify-space-between" *ngFor="let eptSummary of payroll.eptSummariesNonQc">
    <p>
        {{ 'payroll.records.ept.' + eptSummary.jurisdictionArea | translate }} ({{ eptSummary.jurisdictionArea }}
        {{ eptSummary.details.displayName }})
    </p>
    <p>{{ eptSummary.periodBalanceDue | currency }}</p>
</div>
<div class="flex justify-space-between">
    <p class="font-bold">{{ 'payroll.records.details.provincialHealthAndEducationTotal' | translate }}:</p>
    <p class="font-bold">{{ payroll.totalEptSummariesNonQc | currency }}</p>
</div>

<hr />

<div class="flex justify-space-between">
    <p class="font-bold text-large">{{ 'payroll.records.details.otherRemittancesTotal' | translate }}:</p>
    <p class="font-bold text-large">{{ payroll.totalOtherRemittances | currency }}</p>
</div>
